import { useDispatch } from "react-redux";
import { setToggleMenuShown } from "../store/uiSlice";
import { useSelector } from "react-redux";
export function handleClickOutsideMenu(event) {
    if (!(event.target instanceof Element))
        return;
    const target = event.target;
    if (target.id === 'toggle-menu')
        return;
    const dispatch = useDispatch();
    const toggleMenuShownState = useSelector((state) => state.ui.toggleMenuShown);
    if (!toggleMenuShownState)
        return;
    dispatch(setToggleMenuShown(false));
}
